import BaseAPI, { querySuffix } from "./BaseAPI";

function actorHeaders(actorId, key) {
    return {
        ...(actorId ? { "X-Acting-User-ID": actorId } : {}),
        ...(key ? { "Idempotency-Key": key } : {})
    };
}

export default class TaskAPI extends BaseAPI {
    constructor(emitter) {
        super(emitter, "tasks", "task");
    }

    async ListPage(params = {}, { actorId, signal } = {}) {
        return this.readPage("", params, { actorId, signal });
    }

    async Count(locationId, { actorId, signal } = {}) {
        return this._request("get", this._url(`/count${querySuffix({ location_id: locationId })}`), null,
            { signal, headers: actorHeaders(actorId) });
    }

    async ReportPage(params = {}, options = {}) {
        return this.readPage("/report", params, options);
    }

    async HistoryPage(id, params = {}, options = {}) {
        return this.readPage(`/${encodeURIComponent(id)}/history`, params, options);
    }

    async readPage(path, params, { actorId, signal }) {
        const response = await this._request(
            "get",
            this._url(path + querySuffix({ limit: 50, ...params })),
            null,
            { fullResponse: true, signal, headers: actorHeaders(actorId) }
        );
        return {
            data: response.data.data || [],
            next_page_token: response.data.next_page_token || "",
            total_count: response.data.total_count || 0
        };
    }

    async List(params = {}, options = {}) {
        const tasks = [];
        let token = "";
        do {
            const page = await this.ListPage({ ...params, page_token: token }, options);
            tasks.push(...page.data);
            token = page.next_page_token;
        } while (token);
        return tasks;
    }

    async Add(data, key, actorId) {
        const saved = await this._request("post", this._url(), data, {
            headers: actorHeaders(actorId, key)
        });
        this._emit("add", saved.id);
        return saved;
    }

    async Update(id, data, actorId) {
        const saved = await this._request("put", this._url(`/${id}`), data, {
            headers: actorHeaders(actorId)
        });
        this._emit("update", id);
        return saved;
    }
}
